import React, { useState, useEffect } from 'react';

import Plantilla from './plantillas/Plantilla';
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Spinner from './Spinner';

import { createAPIEndpoint } from '../api/index'
import { getConfiguration, ENDPOINTS } from '../api/config'

import { getStudentMetadata } from '../helper/studentMetadata'

const Contactanos = () => {
    const [showSpinner, setShowSpinner] = useState(false);
    const [contactLinks, setContactLinks] = useState(null);

    const getContactUsLinks = () => {
        setShowSpinner(true);

        const studentMetadata = getStudentMetadata();

        const request = {
            matricula: studentMetadata?.matricula,
            institucion: studentMetadata?.institucion,
            campus: studentMetadata?.campus,
        }

        createAPIEndpoint(ENDPOINTS.contactUs)
            .post(request)
            .then(res => {
                //debugger;
                //console.log(res);

                if (!res || !res.data) {
                    setContactLinks(null);
                    return;
                }
                
                setContactLinks(res.data);
            })
            .catch((err) => {
                console.error({ err })
                //setError(pageErrors.unexpectedError);
            }).finally(() => {
                setShowSpinner(false);
            });
    };


    useEffect(() => {
        getContactUsLinks()
    }, []);


    return (<>
        <div className="container">
            <Spinner show={showSpinner} />

            <Plantilla id="Contactanos"></Plantilla>

            {contactLinks &&
                <div className="contactanos ">
                    {contactLinks.campus && (<>
                        <Row className="mb-2 mt-2">
                            <Col className="d-grid gap-2">
                                <a className="btn btn-link custom-button" href={"tel:" + contactLinks.campus}>
                                    <div>
                                        Contacta a tu Campus
                                    </div>
                                    <div>
                                        <span className="material-symbols-outlined icon">call</span>
                                    </div>
                                </a>
                            </Col>
                        </Row >
                    </>)}

                    {contactLinks.empleabilidad && (<>
                        <Row className="mb-2 mt-2">
                            <Col className="d-grid gap-2">
                                <a className="btn btn-link custom-button" href={"tel:" + contactLinks.empleabilidad}>
                                    <div>
                                        Oficina de empleabilidad
                                    </div>
                                    <div>
                                        <span className="material-symbols-outlined icon">call</span>
                                    </div>
                                </a>
                            </Col>
                        </Row >
                    </>)}

                    {contactLinks.whatsapp && (<>
                        <Row className="mb-2 mt-2">
                            <Col className="d-grid gap-2">
                                <a className="btn btn-link custom-button" rel="noreferrer" target="_blank" href={"http://wa.me/" + contactLinks.whatsapp} >
                                    <div>
                                        Mesa de Servicio
                                    </div>
                                    <div>
                                        <img alt="whatsapp" src="images/icons8-whatsapp.svg" style={{ filter: "invert(20%) sepia(97%) saturate(1661%) hue-rotate(182deg) brightness(91%) contrast(101%)" }} />
                                    </div>
                                </a>
                            </Col>
                        </Row >
                    </>)}

                    {contactLinks.mail && (<>
                        <Row className="mb-2 mt-2">
                            <Col className="d-grid gap-2">
                                <a className="btn btn-link custom-button" href={"mailto:" + contactLinks.mail}>
                                    <div>
                                        Mesa de Servicio
                                    </div>
                                    <div>
                                        <span className="material-symbols-outlined icon">mail</span>
                                    </div>
                                </a>
                            </Col>
                        </Row >
                    </>)}

                    {contactLinks.mentoria && (<>
                        <Row className="mb-2 mt-2">
                            <Col className="d-grid gap-2">
                                <a className="btn btn-link custom-button" href={"mailto:" + contactLinks.mentoria}>
                                    <div>
                                        Mentoría
                                    </div>
                                    <div>
                                        <span className="material-symbols-outlined icon">mail</span>
                                    </div>
                                </a>
                            </Col>
                        </Row >
                    </>)}

                    {contactLinks.buzon && (<>
                        <Row className="mb-2 mt-2">
                            <Col className="d-grid gap-2">
                                <a className="btn btn-link custom-button" href={"tel:" + contactLinks.buzon}>
                                    <div>
                                        Buzón de sugerencias Aliat
                                    </div>
                                    <div>
                                        <span className="material-symbols-outlined icon">sms</span>
                                    </div>
                                </a>
                            </Col>
                        </Row >
                    </>)}

                    <div className="mt-4 mb-3">
                        <center><h5>Nuestras redes sociales</h5></center>
                    </div>

                    <div style={{ display: "flex" }}>
                        <div className="col-8">
                            {contactLinks.facebook1 && (<div className="col-12">
                                <a className="btn btn-link facebook-button" rel="noreferrer" target="_blank" href={contactLinks.facebook1} >
                                    <div>
                                        <img alt="facebook" style={{ height: "24px" }} src="images/facebook_logo_icon.png" />
                                    </div>
                                    <div style={{ paddingInline: "10px" }}>
                                        {contactLinks.marca}
                                    </div>
                                </a>
                            </div>)}

                            {contactLinks.facebook2 && (<div className="col-12">
                                <a className="btn btn-link facebook-button" rel="noreferrer" target="_blank" href={contactLinks.facebook2} >
                                    <div>
                                        <img alt="facebook" style={{ height: "24px" }} src="images/facebook_logo_icon.png" />
                                    </div>
                                    <div style={{paddingInline:"10px"} }>
                                        Mi Campus
                                    </div>
                                </a>
                            </div>)}
                        </div>

                        <div className="col-4" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                            {contactLinks.instagram && (<>
                                <a className="btn1 btn-link1 facebook-button" rel="noreferrer" target="_blank" href={contactLinks.instagram} >
                                    <div>
                                        <img alt="instagram" style={{ height: "36px", margin: "10px" }} src="images/instagram_logo_icon.png" />
                                    </div>
                                </a>
                            </>)}

                            {contactLinks.twitter && (<>
                                <a className="btn1 btn-link1 facebook-button" rel="noreferrer" target="_blank" href={contactLinks.twitter} >
                                    <div>
                                        <img alt="twitter_x" style={{ height: "36px", margin: "10px" }} src="images/twitter_x_logo_icon.png" />
                                    </div>
                                </a>
                            </>)}
                        </div>
                    </div>
                </div>
            }
        </div>
    </>);
};

export default Contactanos;